import './index.less';

import React, { useEffect } from 'react';
import { ProTable } from 'react-pro-components';
import { ProTableProps } from 'react-pro-components/typings/components/pro-table/types';
import { Button } from 'ssc-ui-react';

import { $gt, VueCtxRouter, VueCtxStore } from '@/common/appCtx';

import api from '../api';

interface AttendanceHistoryModelType {
  station_id: string;
  slot_code: string;
  slot_name: string;
  start_time: number;
  cross_day: string;
  end_time: number;
}

const AttendanceHistoryData = () => {
  const [dataSource, setDataSource] = React.useState<any[]>([]);
  const [pagination, setPagination] = React.useState({ current: 1, pageSize: 10, total: 0 });
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<(string | number)[]>([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newKeys: (string | number)[]) => setSelectedRowKeys(newKeys),
  };

  const fetchData = async (params: any) => {
    try {
      const query = VueCtxRouter.currentRoute.query;
      const { data = {} } = await api.exportHistoryList({
        ...params.form,
        pageno: params.pagination?.current || 1,
        count: params.pagination?.pageSize || 20,
        staff_type: +query.staff_type,
        clock_model: +query.clock_model,
      });
      const { list = [], pageno, count, total = 0 } = data;
      setDataSource(list);
      setPagination({ current: pageno, pageSize: count, total });
    } catch (e) {
      console.error('load timeslot list error: ', e);
    }
  };

  const updateBreadcrumb = () => {
    const query = VueCtxRouter.currentRoute.query;
    const breadcrumb = [
      { link: undefined, title: $gt('Workforce Management') },
      {
        link: query.clock_model === '1' ? '/attendance/index' : '/attendanceNew/index',
        title: query.clock_model === '1' ? $gt('Attendance') : $gt('New Attendance'),
      },
      { link: '', title: $gt('Historical Attendance Data') },
    ];
    VueCtxStore.dispatch('sharedBreadcrumb/updateBreadcrumb', breadcrumb);
  };

  const downloadSelect = () => {
    rowSelection.selectedRowKeys.forEach((url) => {
      window.open(url as string);
    });
  };

  const proTableProps: ProTableProps<AttendanceHistoryModelType, any> = {
    table: {
      dataSource,
      columns: [
        {
          title: $gt('Month'),
          dataIndex: 'month',
          width: 100,
        },
        {
          title: $gt('File Name'),
          dataIndex: 'file_name',
          width: 300,
          render: file_name => <p className="file-name">{file_name}</p>,
        },
      ],
      actionColumn: {
        actions: value => [
          {
            children: $gt('Download All'),
            onClick: () => {
              window.open(value.downLoad_url);
            }
          },
        ],
        width: 80,
      },
      rowKey: 'downLoad_url',
      rowSelection,
      pagination,
      scroll: { x: true },
    },
    fetchData,
  };

  useEffect(() => {
    updateBreadcrumb();
  }, []);

  return (
    <div className="attendance-history-data">
      <div className="attendance-download-selected">
        <Button
          disabled={rowSelection.selectedRowKeys.length === 0}
          onClick={downloadSelect}
        >{ $gt('Download Selected') }</Button>
      </div>
      <ProTable {...proTableProps} />
    </div>
  );
};

export default AttendanceHistoryData;
